import React from "react";
import "./OceShaSection6.css";

import logoImg from "../assets/ocesha_images/section6/logo.png";
import dashboardImg from "../assets/ocesha_images/section6/dashboard.png";
import connectorImg from "../assets/ocesha_images/section6/left-connector.png";
import blogThumb from "../assets/ocesha_images/section6/thumb-blog.png";
import youtubeThumb from "../assets/ocesha_images/section6/thumb-youtube.png";

const features = [
  {
    icon: "✦",
    title: (
      <>
        AI-Generated
        <br />
        Marketing Content
      </>
    ),
    body: (
      <>
        Blogs, social posts, video clips,
        <br />
        images, infographics, and more —
        <br />
        all generated from your course.
      </>
    ),
  },
  {
    icon: "▦",
    title: (
      <>
        One-Click
        <br />
        Scheduling &amp; Publishing
      </>
    ),
    body: (
      <>
        Schedule and publish content
        <br />
        across all major platforms
        <br />
        with one click.
      </>
    ),
  },
  {
    icon: "⌕",
    title: (
      <>
        SEO &amp; AI-Engine
        <br />
        Discoverability
      </>
    ),
    body: (
      <>
        Get found in search engines
        <br />
        and AI platforms to help more
        <br />
        students discover your course.
      </>
    ),
  },
  {
    icon: "▥",
    title: (
      <>
        More Visibility.
        <br />
        More Students.
        <br />
        More Revenue.
      </>
    ),
    body: (
      <>
        Reach the right audience and
        <br />
        grow your course business
        <br />
        with powerful tools.
      </>
    ),
  },
];

const values = [
  {
    icon: "👥",
    title: "Build Your Audience",
    body: (
      <>
        Reach more students
        <br />
        in your niche.
      </>
    ),
  },
  {
    icon: "🚀",
    title: "Scale Effortlessly",
    body: (
      <>
        Automate teaching,
        <br />
        marketing, and growth.
      </>
    ),
  },
  {
    icon: "◎",
    title: "Expand Your Impact",
    body: (
      <>
        Reach learners worldwide
        <br />
        and make a bigger difference.
      </>
    ),
  },
  {
    icon: "★",
    title: "Create Long-Term Value",
    body: (
      <>
        A sustainable business
        <br />
        built around your knowledge.
      </>
    ),
  },
];

interface OceShaSection6Props {
  onStartFree?: () => void;
}

const OceShaSection6: React.FC<OceShaSection6Props> = ({
  onStartFree,
}) => {
  return (
    <section
      className="ocsec6-section"
      aria-labelledby="ocsec6-growth-title"
    >
      {/* =====================================================
          MAIN ROUNDED CARD
          ===================================================== */}

      <div className="ocsec6-card">

        {/* =================================================
            BRAND
            ================================================= */}

        <div
          className="ocsec6-brand"
          aria-label="OceSha.ai"
        >
          <img
            src={logoImg}
            alt="OceSha.ai"
          />
        </div>


        {/* =================================================
            HEADER
            ================================================= */}

        <div className="ocsec6-header">

          <div className="ocsec6-badge">
            <span
              className="ocsec6-ico"
              aria-hidden="true"
            >
              ▥
            </span>

            AI-POWERED GROWTH
          </div>


          <h2
            id="ocsec6-growth-title"
            className="ocsec6-h2"
          >
            <span className="ocsec6-gradient">
              Grow
            </span>{" "}
            Your Course Business.
          </h2>


          <p className="ocsec6-subtitle">
            OceSha gives you everything you need to reach
            more learners, increase visibility,
            <br className="ocsec6-desktop-break" />
            and turn your courses into a lasting business.
          </p>

        </div>


        {/* =================================================
            MAIN CONTENT
            ================================================= */}

        <div className="ocsec6-main-grid">

          {/* ---------------------------------------------
              LEFT FEATURES
              --------------------------------------------- */}

          <div className="ocsec6-features-left">

            {features.map((feature, idx) => (
              <article
                className="ocsec6-feature"
                key={idx}
              >
                <div
                  className="ocsec6-feature-icon"
                  aria-hidden="true"
                >
                  {feature.icon}
                </div>

                <div>
                  <h3>
                    {feature.title}
                  </h3>

                  <p>
                    {feature.body}
                  </p>
                </div>
              </article>
            ))}

          </div>


          {/* ---------------------------------------------
              CONNECTOR
              --------------------------------------------- */}

          <div
            className="ocsec6-feature-lines"
            aria-hidden="true"
          >
            <img
              src={connectorImg}
              alt=""
            />
          </div>


          {/* ---------------------------------------------
              CENTER DASHBOARD
              --------------------------------------------- */}

          <div className="ocsec6-center-visual">

            <img
              className="ocsec6-dashboard"
              src={dashboardImg}
              alt="OceSha marketing dashboard with AI-generated content and instructor"
            />

          </div>


          {/* ---------------------------------------------
              RIGHT CONTENT CARDS
              --------------------------------------------- */}

          <div className="ocsec6-right-cards">

            {/* Blog */}

            <article
              className="
                ocsec6-social-card
                ocsec6-blog
              "
            >
              <div>

                <div className="ocsec6-card-head">
                  <span className="ocsec6-platform">
                    ▤
                  </span>

                  Blog Post
                </div>

                <strong>
                  The Future of
                  <br />
                  AI Education
                </strong>

                <div className="ocsec6-fake-line ocsec6-w85" />
                <div className="ocsec6-fake-line ocsec6-w55" />

              </div>

              <img
                className="ocsec6-thumb"
                src={blogThumb}
                alt=""
              />
            </article>


            {/* Social */}

            <article
              className="
                ocsec6-social-card
                ocsec6-social
              "
            >
              <div className="ocsec6-card-head">
                <span className="ocsec6-platform">
                  ↗
                </span>

                Social Post
              </div>

              <strong>
                Your next
                <br />
                update is on
                <br />
                its way.
              </strong>

              <div className="ocsec6-fake-line ocsec6-w85" />
              <div className="ocsec6-fake-line ocsec6-w70" />

            </article>


            {/* LinkedIn */}

            <article
              className="
                ocsec6-social-card
                ocsec6-linkedin
              "
            >
              <div className="ocsec6-card-head">
                <span
                  className="
                    ocsec6-platform
                    ocsec6-li
                  "
                >
                  in
                </span>

                LinkedIn Post
              </div>

              <strong>
                Real skills.
                <br />
                Real opportunities.
              </strong>

              <div className="ocsec6-fake-line ocsec6-w85" />
              <div className="ocsec6-fake-line ocsec6-w55" />

            </article>


            {/* YouTube */}

            <article
              className="
                ocsec6-social-card
                ocsec6-youtube
              "
            >
              <img
                className="ocsec6-yt-thumb"
                src={youtubeThumb}
                alt=""
              />

              <div>

                <div className="ocsec6-card-head">
                  <span
                    className="
                      ocsec6-platform
                      ocsec6-yt
                    "
                  >
                    ▶
                  </span>

                  YouTube Video
                </div>

                <strong>
                  Learn · Build · Succeed
                </strong>

                <div className="ocsec6-fake-line ocsec6-w85" />
                <div className="ocsec6-fake-line ocsec6-w70" />
                <div className="ocsec6-fake-line ocsec6-w55" />

              </div>
            </article>

          </div>

        </div>


        {/* =================================================
            BOTTOM VALUE STRIP
            ================================================= */}

        <div className="ocsec6-bottom-strip">

          {values.map((value) => (
            <div
              className="ocsec6-value"
              key={value.title}
            >
              <div
                className="ocsec6-value-icon"
                aria-hidden="true"
              >
                {value.icon}
              </div>

              <div>
                <strong>
                  {value.title}
                </strong>

                <span>
                  {value.body}
                </span>
              </div>
            </div>
          ))}

        </div>

      </div>


      {/* =====================================================
          START FREE BUTTON
          ===================================================== */}

      <div className="ocsec6-action">
        <button
          type="button"
          className="ocsec6-start-button"
          onClick={onStartFree}
        >
          Start Free
        </button>
      </div>

    </section>
  );
};

export default OceShaSection6;